
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 72 72"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1126","transform":"translate(-1804 -971)"}},[_c('circle',{attrs:{"data-name":"Ellipse 158","cx":"36","cy":"36","r":"36","transform":"translate(1804 971)","fill":"#ffd93e","opacity":".6"}}),_c('g',{attrs:{"data-name":"Group 1125","fill":"none","stroke":"#6d66a2","stroke-linecap":"round","stroke-width":"6"}},[_c('path',{attrs:{"data-name":"Path 1018","d":"M1840.317 1023.454v-32.527"}}),_c('path',{attrs:{"data-name":"Path 1017","d":"M1826.723 1003.171l11.314-11.313a3.179 3.179 0 014.495 0l10.825 10.824","stroke-miterlimit":"10"}})])])])
          )
        }
      }
    